import React, { Component } from 'react';
import { Link } from 'react-router';
import moment from 'moment';

import './style.css';

class Footer extends Component {


  render() {
    return (
      <footer className='admn-footer'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12 col-md-6 mb-3 mb-lg-0'>
              <div className="admn-social justify-content-center justify-content-md-start">
                <span>Follow Us</span>
                <nav>
                  <a className="u-icon-v1 u-icon-size--sm u-shadow-v32 g-color-primary g-color-white--hover g-bg-white g-bg-primary--hover rounded-circle" href="https://twitter.com/aczdelhi">
                    <i className="g-font-size-default fa fa-twitter"></i>
                  </a>
                  <a className="u-icon-v1 u-icon-size--sm u-shadow-v32 g-color-primary g-color-white--hover g-bg-white g-bg-primary--hover rounded-circle" href="https://www.facebook.com/AdmizzionzCampuzIndia">
                    <i className="g-font-size-default fa fa-facebook"></i>
                  </a>
                  <a className="u-icon-v1 u-icon-size--sm u-shadow-v32 g-color-primary g-color-white--hover g-bg-white g-bg-primary--hover rounded-circle" href="https://www.linkedin.com/company/admizzionz-campuz/">
                    <i className="g-font-size-default fa fa-linkedin"></i>
                  </a>
                </nav>
              </div>
            </div>
            <div className='col-sm-12 col-md-6 text-center text-md-right'>
              <p>© {moment().format('YYYY')} All Rights Reserved, <a className='auth-link' href="http://www.admizzionzcampuz.com/">Admizzionz Campuz</a></p>
              <p><Link className="auth-link" to="/privacyPolicy">Privacy Policy</Link>&nbsp;&nbsp;.&nbsp;&nbsp;<Link className="auth-link" to="/termAndConditions">Terms and Conditions</Link></p>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer/index.js
 **/